var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3346 5.66667H20.3346M7.0013 5.66667H1.66797M28.3346 20.3333H23.0013M9.66797 20.3333H1.66797M12.3346 10.3333C12.9475 10.3333 13.5543 10.2126 14.1205 9.97811C14.6867 9.74358 15.2011 9.39984 15.6345 8.9665C16.0678 8.53316 16.4116 8.01871 16.6461 7.45252C16.8806 6.88634 17.0013 6.2795 17.0013 5.66667C17.0013 5.05383 16.8806 4.447 16.6461 3.88081C16.4116 3.31462 16.0678 2.80018 15.6345 2.36684C15.2011 1.9335 14.6867 1.58975 14.1205 1.35523C13.5543 1.12071 12.9475 1 12.3346 1C11.097 1 9.90997 1.49167 9.0348 2.36684C8.15963 3.24201 7.66797 4.42899 7.66797 5.66667C7.66797 6.90434 8.15963 8.09133 9.0348 8.9665C9.90997 9.84167 11.097 10.3333 12.3346 10.3333V10.3333ZM17.668 25C18.9056 25 20.0926 24.5083 20.9678 23.6332C21.843 22.758 22.3346 21.571 22.3346 20.3333C22.3346 19.0957 21.843 17.9087 20.9678 17.0335C20.0926 16.1583 18.9056 15.6667 17.668 15.6667C16.4303 15.6667 15.2433 16.1583 14.3681 17.0335C13.493 17.9087 13.0013 19.0957 13.0013 20.3333C13.0013 21.571 13.493 22.758 14.3681 23.6332C15.2433 24.5083 16.4303 25 17.668 25V25Z",
    stroke: "#979797",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c51a202df3f08b9105e58e720e688c6e.svg";
export { ForwardRef as ReactComponent };